import React from "react";
import {
  FaChartLine,
  FaShieldAlt,
  FaUsers,
  FaBullseye,
  FaAward,
} from "react-icons/fa";
import Header from "../General/Header";
import Footer from "./Footer";

const About = () => {
  return (
    <>
      <Header />

      <div
        style={{
          background: "#0f172a",
          color: "#fff",
          minHeight: "100vh",
        }}
      >
        {/* Hero Section */}
        <section
          style={{
            padding: "90px 20px",
            textAlign: "center",
            background:
              "linear-gradient(135deg, #0f172a 0%, #1e293b 50%, #111827 100%)",
          }}
        >
          <h1
            style={{
              fontSize: "55px",
              fontWeight: "bold",
              marginBottom: "20px",
            }}
          >
            About Our Trading Platform
          </h1>

          <p
            style={{
              maxWidth: "850px",
              margin: "auto",
              color: "#cbd5e1",
              fontSize: "20px",
              lineHeight: "34px",
            }}
          >
            We provide secure, fast, and advanced trading solutions for
            traders worldwide. Our mission is to make trading simple,
            transparent, and accessible for everyone.
          </p>
        </section>

        {/* About Section */}
        <section
          style={{
            padding: "80px 20px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "auto",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))",
              gap: "40px",
              alignItems: "center",
            }}
          >
            <div>
              <img
                
                src="https://images.unsplash.com/photo-1559526324-593bc073d938?q=80&w=1200&auto=format&fit=crop"
                alt="Trading"
                style={{
                  width: "100%",
                  borderRadius: "20px",
                }}
              />
            </div>

            <div>
              <h2
                style={{
                  fontSize: "42px",
                  marginBottom: "20px",
                }}
              >
                Who We Are
              </h2>

              <p
                style={{
                  color: "#cbd5e1",
                  lineHeight: "32px",
                  fontSize: "18px",
                }}
              >
                Our platform helps traders invest confidently using
                modern technology, real-time market insights, and secure
                financial systems. We focus on delivering a smooth and
                professional trading experience for beginners and experts.
              </p>

              <p
                style={{
                  color: "#cbd5e1",
                  lineHeight: "32px",
                  fontSize: "18px",
                  marginTop: "20px",
                }}
              >
                With advanced tools and expert guidance, we help users
                grow their portfolios and make smarter trading decisions.
              </p>
            </div>
          </div>
        </section>

        {/* Features Section */}
        <section
          style={{
            padding: "80px 20px",
            background: "#111827",
          }}
        >
          <h2
            style={{
              textAlign: "center",
              fontSize: "42px",
              marginBottom: "50px",
            }}
          >
            Why Traders Trust Us
          </h2>

          <div
            style={{
              maxWidth: "1200px",
              margin: "auto",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
              gap: "25px",
            }}
          >
            <div
              style={{
                background: "#1e293b",
                padding: "35px",
                borderRadius: "18px",
                textAlign: "center",
              }}
            >
              <FaShieldAlt size={45} color="#22c55e" />

              <h3 style={{ marginTop: "20px" }}>Secure Trading</h3>

              <p style={{ color: "#cbd5e1", marginTop: "12px" }}>
                Advanced security systems protect your account and
                transactions.
              </p>
            </div>

            <div
              style={{
                background: "#1e293b",
                padding: "35px",
                borderRadius: "18px",
                textAlign: "center",
              }}
            >
              <FaChartLine size={45} color="#22c55e" />

              <h3 style={{ marginTop: "20px" }}>Live Analytics</h3>

              <p style={{ color: "#cbd5e1", marginTop: "12px" }}>
                Access real-time charts, analytics, and trading insights.
              </p>
            </div>

            <div
              style={{
                background: "#1e293b",
                padding: "35px",
                borderRadius: "18px",
                textAlign: "center",
              }}
            >
              <FaUsers size={45} color="#22c55e" />

              <h3 style={{ marginTop: "20px" }}>Expert Team</h3>

              <p style={{ color: "#cbd5e1", marginTop: "12px" }}>
                Our professional team supports traders 24/7 globally.
              </p>
            </div>
          </div>
        </section>

        {/* Mission & Vision */}
        <section
          style={{
            padding: "80px 20px",
          }}
        >
          <div
            style={{
              maxWidth: "1200px",
              margin: "auto",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
              gap: "30px",
            }}
          >
            <div
              style={{
                background: "#1e293b",
                padding: "40px",
                borderRadius: "20px",
              }}
            >
              <FaBullseye size={45} color="#22c55e" />

              <h2 style={{ marginTop: "20px" }}>Our Mission</h2>

              <p
                style={{
                  color: "#cbd5e1",
                  lineHeight: "30px",
                  marginTop: "15px",
                }}
              >
                To provide a transparent, secure, and innovative trading
                environment for traders across the world.
              </p>
            </div>

            <div
              style={{
                background: "#1e293b",
                padding: "40px",
                borderRadius: "20px",
              }}
            >
              <FaAward size={45} color="#22c55e" />

              <h2 style={{ marginTop: "20px" }}>Our Vision</h2>

              <p
                style={{
                  color: "#cbd5e1",
                  lineHeight: "30px",
                  marginTop: "15px",
                }}
              >
                To become one of the most trusted global trading
                platforms by empowering every investor with modern tools.
              </p>
            </div>
          </div>
        </section>

  
        <section
          style={{
            background: "#111827",
            padding: "70px 20px",
          }}
        >
          <div
            style={{
              maxWidth: "1100px",
              margin: "auto",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: "25px",
              textAlign: "center",
            }}
          >
            <div>
              <h2 style={{ fontSize: "40px", color: "#22c55e" }}>
                50K+
              </h2>

              <p>Active Traders</p>
            </div>

            <div>
              <h2 style={{ fontSize: "40px", color: "#22c55e" }}>
                ₹100Cr+
              </h2>

              <p>Trading Volume</p>
            </div>

            <div>
              <h2 style={{ fontSize: "40px", color: "#22c55e" }}>
                15+
              </h2>

              <p>Countries Served</p>
            </div>

            <div>
              <h2 style={{ fontSize: "40px", color: "#22c55e" }}>
                24/7
              </h2>

              <p>Customer Support</p>
            </div>
          </div>
        </section>

       
        <section
          style={{
            padding: "90px 20px",
            textAlign: "center",
          }}
        >
          <h2
            style={{
              fontSize: "45px",
              marginBottom: "20px",
            }}
          >
            Start Your Trading Journey Today
          </h2>

          <p
            style={{
              color: "#cbd5e1",
              fontSize: "18px",
              marginBottom: "35px",
            }}
          >
            Join thousands of traders using our secure and advanced
            trading platform.
          </p>

          <button
            style={{
              padding: "16px 35px",
              background: "#22c55e",
              border: "none",
              borderRadius: "10px",
              color: "#fff",
              fontSize: "18px",
              cursor: "pointer",
              fontWeight: "600",
            }}
          >
            Get Started
          </button>
        </section>
      </div>
      <Footer/>
    </>
  );
};

export default About;

